export default [
    
    //Examples
    // {
    //     name: 'napoleon',
    //     type: 'texture',
    //     path: './images/products/napoleon/1.jpg'

    // },

    // {
    //     name: 'ambientSound',
    //     type: 'audio',
    //     path: './sounds/ambient.mp3'

    // },



]

